import { NextLinkButton } from "@/lib/next-mui/NextLinkButton";
import { SignedIn, SignedOut } from "@/modules/authentication";
import { observer } from "mobx-react";
import { CreditAmountPickerState } from "./CreditAmountPickerState";
import { topupHref } from "./topupLinkParams";

// Signed-in visitors go straight to the topup form with their selection
// prefilled; everyone else needs an account first. Both wrappers render
// nothing while the session loads.
export const PricingCallToAction = observer(
  ({ state }: { state: CreditAmountPickerState }) => {
    return (
      <>
        <SignedIn>
          <NextLinkButton
            href={topupHref({
              amount: state.selectedAmount,
              buyerType: state.buyerType,
              countryCode: state.countryCode,
            })}
            variant="contained"
            size="large"
          >
            Top up balance
          </NextLinkButton>
        </SignedIn>

        <SignedOut>
          <NextLinkButton href="/login" variant="contained" size="large">
            Get Started
          </NextLinkButton>
        </SignedOut>
      </>
    );
  },
);
